
var moment = require("moment-jalaali");



const nameMonth = (NumMonth) => {

    let Month = "";

    switch (NumMonth) {

        case 1:
            Month = "فروردین";
            break;
        case 2:
            Month = "اردیبهشت";
            break;
        case 3:
            Month = "خرداد";
            break;
        case 4:
            Month = "تیر";
            break;
        case 5:
            Month = "مرداد";
            break;
        case 6:
            Month = "شهریور";
            break;
        case 7:
            Month = "مهر";
            break;
        case 8:
            Month = "آبان";
            break;
        case 9:
            Month = "آذر";
            break;
        case 10:
            Month = "دی";
            break;
        case 11:
            Month = "بهمن";
            break;
        case 12:
            Month = "اسفند";
            break;
        default:
            Month = "نامشخص";
            break;
    }
    return Month;

}


export const myDate = (date) => {
    var Mj = moment(date, 'jYYYY/jM/jD').jMonth() + 1;
    var Mjj = nameMonth(Mj);
    var Yj = moment(date, 'jYYYY/jM/jD').jYear();
    var Dj = moment(date, 'jYYYY/jM/jD').jDate();
    var CurrentDateJ = Dj + ' ' + Mjj + ' ' + Yj
    return (CurrentDateJ);
}


